// =============================================================================
// System-Admin: Datenbereinigung / Werksreset – Frontend-Service (Folgeprompt 17)
// -----------------------------------------------------------------------------
// Der System-Admin-Bereich liegt unter ".../api/system-admin/". Die Basis wird
// aus API_URL (".../api/test/") abgeleitet (kein Hardcoding der Origin).
// =============================================================================

import axios from "axios";
import authHeader from "./auth-header";

axios.defaults.withCredentials = true;

const API_URL = process.env.REACT_APP_API_URL || "";
const SYS_BASE = API_URL.replace(/\/api\/test\/?$/, "") + "/api/system-admin/";

// Fachliche Entitaeten (Menue-Struktur) laden.
const getEntities = () => {
  return axios.get(SYS_BASE + "entities", { headers: authHeader() });
};

// Datensaetze einer Entitaet (Suche + Pagination).
const getRecords = (payload) => {
  return axios.post(SYS_BASE + "records", payload, { headers: authHeader() });
};

// Dry-Run inkl. Kaskade (kein Loeschen).
const previewWipe = (payload) => {
  return axios.post(SYS_BASE + "wipe/preview", payload, { headers: authHeader() });
};

// Ausfuehrung inkl. Kaskade (transaktional, mit Vorab-Dump).
const executeWipe = (payload) => {
  return axios.post(SYS_BASE + "wipe/execute", payload, { headers: authHeader() });
};

// Liste "Gerade erzeugt": seitenweise inkl. ausgeblendeter Eintraege.
const getLiveEntries = (params) => {
  return axios.get(SYS_BASE + "live-entries", { params, headers: authHeader() });
};

// Eintraege aus "Gerade erzeugt" und der Live-Karte ausblenden.
const hideLiveEntries = (placeIds) => {
  return axios.post(SYS_BASE + "live-entries/hide", { place_ids: placeIds }, { headers: authHeader() });
};

// Ausgeblendete Eintraege wiederherstellen.
const restoreLiveEntries = (placeIds) => {
  return axios.post(SYS_BASE + "live-entries/restore", { place_ids: placeIds }, { headers: authHeader() });
};

// Abgelaufenen Eintraegen einen neuen Test-Code geben (Laufzeit in Stunden).
const publishLiveEntries = (placeIds, hours) => {
  return axios.post(SYS_BASE + "live-entries/publish", { place_ids: placeIds, hours }, { headers: authHeader() });
};

// Eintraege endgueltig loeschen.
const deleteLiveEntries = (placeIds) => {
  return axios.post(SYS_BASE + "live-entries/delete", { place_ids: placeIds }, { headers: authHeader() });
};

// Einzelnen Eintrag laden.
const getLiveEntryDetail = (placeId) => {
  return axios.get(SYS_BASE + "live-entries/" + encodeURIComponent(placeId), { headers: authHeader() });
};

// Einzelnen Eintrag aktualisieren.
const updateLiveEntryDetail = (placeId, data) => {
  return axios.put(SYS_BASE + "live-entries/" + encodeURIComponent(placeId), data, { headers: authHeader() });
};

// Werbeflyer hochladen.
const uploadLiveEntryFlyer = (placeId, formData) => {
  return axios.post(
    SYS_BASE + "live-entries/" + encodeURIComponent(placeId) + "/flyer",
    formData,
    { headers: { ...authHeader(), "Content-Type": "multipart/form-data" } }
  );
};

// Werbeflyer loeschen.
const deleteLiveEntryFlyer = (placeId) => {
  return axios.delete(SYS_BASE + "live-entries/" + encodeURIComponent(placeId) + "/flyer", { headers: authHeader() });
};

const systemAdminService = {
  getEntities,
  getRecords,
  previewWipe,
  executeWipe,
  getLiveEntries,
  hideLiveEntries,
  restoreLiveEntries,
  publishLiveEntries,
  deleteLiveEntries,
  getLiveEntryDetail,
  updateLiveEntryDetail,
  uploadLiveEntryFlyer,
  deleteLiveEntryFlyer,
};

export default systemAdminService;
